exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.synthese table {\n  border-collapse : collapse!important;\n}\n.synthese > td {\n  border: 0;\n  vertical-align: top!important;\n}\n.synthese .cell {\n  padding: 0!important;\n}\n.s-input {\n  border-bottom: 1px solid #666;\n}\n[data-sync-scrollbar=\"summaries\"] .el-table__header {\n  display: none\n}\n", ""]);

// exports
